export const tagCustomer = (customer) => {
  window['dataLayer'] = window['dataLayer'] || [];

  const data = window['dataLayer'].find((item) =>
    item.hasOwnProperty('customerId')
  );

  if (!data) {
    window['dataLayer'].push({ customerId: customer.sub });
  }
};
